import React from 'react'

const CollectionCard = () => {
  return (
    <div className='p-4'>Collection Card</div>
  )
}

export default CollectionCard